<template>
  <div>
    <h1>Account Recovery</h1>
    <p>
      Please enter your email connected to the account you're trying to recover.
      <br>
      An email will be sent to you with a link to follow.
    </p>

    <div
      v-if="formErrors.non_field_errors !== undefined"
      class="alert alert-danger"
      role="alert"
    >
      {{ formErrors.non_field_errors[0] }}
    </div>

    <div
      v-if="sendAgain"
      class="alert alert-danger"
      role="alert"
    >
      Email sent. If you did not recieve an email, click resend.
    </div>

    <form @submit.prevent="submitForm()">
      <div class="form-group">
        <label for="email">Email Address</label>
        <input
          id="email"
          v-model="formFields.email"
          type="email"
          required
        >
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Sending
          <spinner />
        </template>
        <template v-else>
          {{ sendAgain ? 'Resend': 'Send' }}
        </template>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      sendAgain: false,
      formFields: {
        email: '',
      },
    };
  },
  methods: {
    async submitForm(resetType) {
      this.formErrors = {};
      this.formSubmitting = true;
      const json = this.copy(this.formFields);
      json.reset_type = resetType;

      const responseData = await this.api({
        url: 'users/emailResetToken/',
        method: 'POST',
        json,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.sendAgain = true;
      } else if (responseData.status === 400) {
        this.formErrors = {
          non_field_errors: [
            'Email does not exist in system.',
          ],
        };
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>
